import styled from "styled-components";

export const ImageSection = styled.div`
  width: 100%;
  margin: 20px 0;
`;
